import React from 'react'
import './style.css'
import { NavLink } from 'react-router-dom'

const SuperAdminSidebar = () => {
    return (
        <>
            <ul className="corporate-sidebar superadmin-sidebar sidebar-space-control">
                <li>
                    <NavLink to="/admin/dashboard" className={({ isActive }) => isActive ? 'active-link' : ''}><i className="fa-solid fa-boxes-stacked"></i>Dashboard</NavLink>
                </li>

                <li>
                    <NavLink to='/admin/users' className={({ isActive }) => isActive ? 'active-link' : ''}><i className="fa-solid fa-users"></i>Users</NavLink>
                </li>

                <li>
                    <NavLink to="/admin/professionals" className={({ isActive }) => isActive ? 'active-link' : ''}><i className="fa-solid fa-user-tie"></i>Professional</NavLink>
                </li>

                <li>
                    <NavLink to="/admin/corporates" className={({ isActive }) => isActive ? 'active-link' : ''}><i className="fa-solid fa-building"></i>Corporate</NavLink>
                </li>

                <li>
                    <NavLink to='/admin/profile/review' className={({ isActive }) => isActive ? 'active-link' : ''}><i class="fa-solid fa-circle-user"></i>Profile Review</NavLink>
                </li>

                {/* <li>
                    <NavLink to="/superadminplan" className={({ isActive }) => isActive ? 'active-link' : ''}><i className="fa-solid fa-chart-line"></i>Plans</NavLink>
                </li> */}

                {/* <li>
                    <NavLink to='/superadminChat' className={({ isActive }) => isActive ? 'active-link' : ''}><i className="fa-regular fa-comment"></i>Chats</NavLink>
                </li> */}

                <li>
                    <NavLink to='/admin/settings' className={({ isActive }) => isActive ? 'active-link' : ''}><i className="fa-solid fa-gear"></i> Settings</NavLink>
                </li>

                {/* <li>
                    <NavLink to='/admin/reports' className={({ isActive }) => isActive ? 'active-link' : ''}><i className="fa-solid fa-file"></i>Reports</NavLink>
                </li> */}
            </ul>
        </>
    )
}

export default SuperAdminSidebar